import { render, staticRenderFns } from "./label-pengiriman-print.vue?vue&type=template&id=40975ef2&"
import script from "./label-pengiriman-print.vue?vue&type=script&lang=js&"
export * from "./label-pengiriman-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports